<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-end align-center>
              <v-flex xs12 md4>
                <v-layout row class="ma-0 py-2">
                  <div>
                    <v-flex class="py-1">Số dư đầu kỳ</v-flex>
                    <v-flex class="py-1">Tổng thu</v-flex>
                    <v-flex class="py-1">Tổng chi</v-flex>
                    <v-flex class="py-1">Số tiền kết chuyển</v-flex>
                    <v-flex class="py-1">Số dư cuối kỳ</v-flex>
                  </div>
                  <div>
                    <v-flex class="py-1 text-right">{{
                      this.opening_balance | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_income | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_expense | formatCurrency
                      }}</v-flex>
                    <v-flex class="py-1 text-right">
                      {{
                        (this.cash_transfer_slip ? this.cash_transfer_slip.amount : 0)
                        | formatCurrency
                      }}
                    </v-flex>
                    <v-flex class="py-1 text-right">
                      {{
                        (this.opening_balance + this.accumulated_balance - (this.cash_transfer_slip ? this.cash_transfer_slip.amount : 0))
                        | formatCurrency
                      }}
                    </v-flex> 
                  </div>
                </v-layout>
              </v-flex>
              <v-flex row xs12 md8>
                <v-layout row justify-content-end align-center>
                  <v-flex xs12 md4>
                    <v-select label="Tài khoản" :disabled="loader" v-model="chosen_wallet_account_id"
                      :items="list_wallet_account" item-text="name" item-value="id"
                      prepend-icon="account_balance_wallet" required hide-details></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                      transition="scale-transition" offset-y full-width min-width="290px" hide-details>
                      <v-text-field slot="activator" v-model="chosen_month" label="Chọn tháng" :disabled="loader"
                        prepend-icon="event" readonly hide-details></v-text-field>
                      <v-date-picker min="2025-01" locale="vi-VI" type="month" v-model="chosen_month" @input="menu_month_picker = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row justify-space-between align-center>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-btn :disabled="loader" @click="print_table = true" color="primary">
                        <v-icon small left>print</v-icon>
                        IN SỔ TIỀN MẶT
                      </v-btn>
                      <v-btn :loader="loader || export_csv.loader" @click="exportCSV" color="green" dark>XUẤT
                        EXCEL</v-btn>
                      <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
                        :rows="export_csv.rows"></export-csv-button>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <div class="mt-3">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div class="d-flex justify-space-between align-center pa-2">
                  <div v-if="!loader">
                  </div>
                  <v-btn @click="createTransferSlip()" color="green" style="max-width: 250px;" :disabled="cash_transfer_slip">
                    <v-icon small class="mr-1">add_box</v-icon>{{cash_transfer_slip ? "Đã kết chuyển tiền mặt" : "Kết chuyển tiền mặt"}}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-card>
              <v-data-table disable-initial-sort :headers="headers" :items="items" item-key="_id" :rows-per-page-items="rowPerPage">
                <template v-slot:items="props">
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.index + 1 }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.receipt_id }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.date_action | formatTimeServer }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.collected_amount || props.item.deposit_amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.amount | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.balance | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap" @click.stop>
                      {{ props.item.accumulated_balance | formatCurrency }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.description }}
                    </td>
                    <td class="text-center text-no-wrap" @click.stop>
                      {{ props.item.room_id }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <print-portal layout="portrait" :open="print_table" @close="print_table = false">
      <print-so-tien-mat :items="cash_transfer_slip ? [...items, { ...cash_transfer_slip, balance: -cash_transfer_slip.amount, date_action: cash_transfer_slip.date_created, accumulated_balance: opening_balance + accumulated_balance - cash_transfer_slip.amount, note: 'Kết chuyển tiền mặt' }]: items"></print-so-tien-mat>
    </print-portal>
  </div>
</template>

<script>
import moment from "moment";
import api from "Api";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton.vue";
import PrintPortal from "Components/Print/PrintPortal";
import PrintSoTienMat from "Components/Print/PrintSoTienMat";
import {
  EXPENSE_ACCOUNT_TYPE_LIST,
  INCOME_ACCOUNT_TYPE_LIST,
  EXPENSE_ACCOUNT_OPTIONS,
  CASH_ACCOUNT_ID_TO_BUILDING_MAPPING,
} from "Constants/db-config.js";
import { formatTimeServer, translateWalletName } from "Helpers";
import { buildParamQuery } from "Helpers";

export default {
  name: "so-ket-chuyen-tien-mat",
  components: {
    ExportCsvButton,
    PrintPortal,
    PrintSoTienMat,
  },
  data() {
    return {
      loader: false,
      headers: [
        {
          text: "Số thứ tự",
          align: "center",
          sortable: false,
          value: "index",
        },
        {
          text: "Số chứng từ",
          align: "center",
          sortable: true,
          value: "receipt_id",
        },
        {
          text: "Ngày",
          align: "center",
          sortable: true,
          value: "date_action",
        },
        {
          text: "Số tiền thu",
          align: "center",
          sortable: true,
          value: "collected_amount",
        },
        {
          text: "Số tiền chi",
          align: "center",
          sortable: true,
          value: "amount",
        },
        {
          text: "Số dư",
          align: "center",
          sortable: true,
          value: "balance",
        },
        {
          text: "Số dư cộng dồn",
          align: "center",
          sortable: true,
          value: "accumulated_balance",
        },
        {
          text: "Nội dung chi tiết",
          align: "center",
          sortable: true,
          value: "note",
        },
        {
          text: "Số phòng",
          align: "center",
          sortable: true,
          value: "room_id",
        },
      ],
      export_csv: {
        loader: false,
        trigger: false,
        title: "",
        rows: [],
      },
      items: [],
      print_table: false,
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      accumulated_balance: 0,
      chosen_wallet_account_id: 6,
      opening_balance: 0,
      total_income: 0,
      total_expense: 0,
      EXPENSE_ACCOUNT_OPTIONS,
      menu_month_picker: false,
      chosen_month: new Date().toISOString().substring(0, 7),
      cash_transfer_slip: null,
    };
  },
  watch: {
    chosen_month: function () {
      this.getData();
    },
    chosen_wallet_account_id: function () {
      this.getData();
    },
    list_wallet_account: function (nv) {
      if (!this.chosen_wallet_account_id) {
        this.chosen_wallet_account_id = nv[0].id;
      }
    },
  },

  mounted() {
    if (this.list_wallet_account.length) {
      this.chosen_wallet_account_id = 6;
      this.getData();
    }
  },
  created() { },
  computed: {
    customTitle() {
      return "Sổ " + translateWalletName(this.chosen_wallet_account_id);
    },
    list_wallet_account() {
      return (
        (this.$store.state.app.wallets &&
          this.$store.state.app.wallets.filter(
            (item) => item.name && item.name.toLowerCase().includes("tiền mặt") && item.name !== 'Tiền mặt'
          )) ||
        []
      );
    },
  },
  methods: {
    resetTable: function () {
      this.getData();
    },
    getData: async function () {
      this.loader = true;

      const params = {
        dateStart: moment(this.chosen_month).format("YYYY-MM-01"),
        dateEnd: moment(this.chosen_month)
          .endOf("month")
          .format("YYYY-MM-DD"),
        walletAccountId: this.chosen_wallet_account_id,
      };

      const query = buildParamQuery(params);
      const results = await Promise.all([
        api.getReceiptRoomAndOther(query),
        api.getDepositReceipts(query),
        api.getDisbursementReceipt(query),
        api.findReceiptCash(query),
      ]);

      const getCashTransferSlipParams = {
        month: this.chosen_month,
        walletAccountId: this.chosen_wallet_account_id,
      };

      const cashTransferSlipData = await api.getCashTransferSlip(buildParamQuery(getCashTransferSlipParams));

      this.items = [];

      this.total_income = 0;

      this.total_expense = 0;

      this.accumulated_balance = 0;

      this.items = results
        .reduce((acc, result) => {
          return acc.concat(result.data);
        }, [])
        .sort((a, b) => {
          const a_date_action = a.date_collected || a.date_created || a.date_deposit;

          const b_date_action = b.date_collected || b.date_created || a.date_deposit;

          return new Date(a_date_action) - new Date(b_date_action);
        })
        .map((item) => {
          let balance = 0;
          const filterExpenseOptions = this.EXPENSE_ACCOUNT_OPTIONS.filter(
            (item) => item.text !== "Chi lương (cũ)"
          );

          if (INCOME_ACCOUNT_TYPE_LIST.includes(item.type)) {
            balance = item.collected_amount || item.deposit_amount;

            this.total_income += balance;

            if (item.type === 'receipt_room') {
              item.description = `Thu tiền phòng ${item.room_id || ''}`;
            } else if (item.type === 'deposit_revenue') {
              item.description = `Thu tiền cọc lần ${item.deposit_type || ''} ${item.room_id || ''}`;
            } else {
               item.description = `Thu khác ${item.note || ''}`
            }

          } else if (EXPENSE_ACCOUNT_TYPE_LIST.includes(item.type) || item.type === 'receipt_cash') {
            balance = -item.amount;

            this.total_expense += item.amount;

            if (item.type === 'receipt_cash') {
              item.description = `Thu tiền mặt ${item.note || ''}`
            } else {
              const foundExpenseOption = filterExpenseOptions.find(
                (option) => option.value === item.type
              );

              item.description = `${foundExpenseOption.text} ${item.room_id || item.note || ''}`
            }
          }

          this.accumulated_balance += balance;

          return {
            ...item,
            date_action: item.date_collected || item.date_created || item.date_deposit,
            balance,
            accumulated_balance: this.accumulated_balance,
          };
        });

      if (cashTransferSlipData.status === 200) {
        this.cash_transfer_slip = cashTransferSlipData.data;
      } else {
				swal.fire("Lỗi", cashTransferSlipData.message, "error");
			}

      this.loader = false;
    },
    createTransferSlip: async function () {
      if (!confirm('Bạn có chắc chắn muốn kết chuyển tiền mặt?')){
        return;
      }
      this.loader = true;

      
      const postData = {
        amount: this.accumulated_balance,
        building: CASH_ACCOUNT_ID_TO_BUILDING_MAPPING[this.chosen_wallet_account_id],
        wallet_account_id: this.chosen_wallet_account_id,
        month: this.chosen_month,
      };

      const data = await api.createCashTransferSlip(postData);

      this.loading = false;

      if (data.status === 200) {
        this.getData();
        swal.fire("Thành công", data.data.message, "success");
      } else swal.fire("Lỗi", data.message, "error");
    },
    exportCSV: function () {
      (this.opening_balance + this.accumulated_balance - (this.cash_transfer_slip ? this.cash_transfer_slip.amount : 0))
      const csvRows = this.cash_transfer_slip ? [...this.items, { 
        ...this.cash_transfer_slip,
        balance: -this.cash_transfer_slip.amount,
        date_action: this.cash_transfer_slip.date_created,
        accumulated_balance: this.opening_balance + this.accumulated_balance - this.cash_transfer_slip.amount,
        note: "Kết chuyển tiền mặt"
      }] : this.items;
      const rows = csvRows.map((item, index) => {
        const row = {};
        for (let field of this.headers) {
          if (field.text === "Số tiền thu") {
            row[field.text] = item.collected_amount || item.deposit_amount;
          } else {
            row[field.text] = item[field.value];
          }
        }
        return { ...row, "Số thứ tự": index + 1 };
      });

      this.export_csv.rows = rows;
      this.export_csv.title = `SoTienMat_${CASH_ACCOUNT_ID_TO_BUILDING_MAPPING[this.chosen_wallet_account_id]}_${this.chosen_month}`;
      this.export_csv.trigger = !this.export_csv.trigger;
    },
    calcTotalAmount: arr =>
      arr.reduce(
        (accumulator, currentReceipt) => {
          let balance = 0;

          if (INCOME_ACCOUNT_TYPE_LIST.includes(currentReceipt.type)) {
            balance = currentReceipt.collected_amount || currentReceipt.deposit_amount;
          } else if (EXPENSE_ACCOUNT_TYPE_LIST.includes(currentReceipt.type)) {
            balance = -currentReceipt.amount;
          }

          accumulator += balance;

          return accumulator;
        },
        0
      ),
  },
};
</script>
